import { colors } from 'ui/theme/colors';
import { ArrowUp } from 'ui/icons/analytics/ArrowUp';
import { ArrowDown } from 'ui/icons/analytics/ArrowDown';
import { HelpTooltip } from 'ui/tooltip/Variants';
import {
  XaiLikelyBoldText,
  XaiLikelyHeader,
  XaiLikelyTile,
  XAILikelyTileContent,
  XAILikelyTileContentText,
  XAILikelyTileToggletipTrigger,
} from '../Styled';

import { Direction } from '../../types';
import {
  TEST_IDS,
  XAI_LIKELY_TILE_LABEL_TEXT,
  XAI_LIKELY_TO_DECREASE_TOOLTIP_TEXT,
  XAI_LIKELY_TO_INCREASE_TOOLTIP_TEXT,
} from '../../constants';

type XAILikelyTileTypes = {
  children?: JSX.Element;
  directionality: Direction.INCREASE | Direction.DECREASE;
};

export const XAILikelyTile = ({ children, directionality }: XAILikelyTileTypes) => {
  const DIRECTIONALITY_TEXT = directionality === Direction.INCREASE ? 'Increase' : 'Decrease';
  const DIRECTIONALITY_TOOLTIP =
    directionality === Direction.INCREASE
      ? XAI_LIKELY_TO_INCREASE_TOOLTIP_TEXT
      : XAI_LIKELY_TO_DECREASE_TOOLTIP_TEXT;
  const DirectionalityIcon =
    directionality === Direction.INCREASE ? (
      <ArrowUp color={colors.purple50} backgroundColor={colors.purple10} />
    ) : (
      <ArrowDown color={colors.purple50} backgroundColor={colors.purple10} />
    );

  return (
    <XaiLikelyTile data-test={`${directionality}-${TEST_IDS.XAILikelyTile}`}>
      <XaiLikelyHeader>
        <XAILikelyTileContent>
          {DirectionalityIcon}
          <XAILikelyTileContentText>
            <XaiLikelyBoldText>{DIRECTIONALITY_TEXT}</XaiLikelyBoldText>
            {XAI_LIKELY_TILE_LABEL_TEXT}
          </XAILikelyTileContentText>
        </XAILikelyTileContent>
        <XAILikelyTileToggletipTrigger>
          <HelpTooltip
            tooltipContent={DIRECTIONALITY_TOOLTIP}
            iconProps={{
              color: colors.secondaryText,
            }}
          />
        </XAILikelyTileToggletipTrigger>
      </XaiLikelyHeader>
      {children}
    </XaiLikelyTile>
  );
};
